import { render, staticRenderFns } from "./associationGoods.vue?vue&type=template&id=826b7916&scoped=true"
import script from "./associationGoods.vue?vue&type=script&lang=js"
export * from "./associationGoods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "826b7916",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('826b7916')) {
      api.createRecord('826b7916', component.options)
    } else {
      api.reload('826b7916', component.options)
    }
    module.hot.accept("./associationGoods.vue?vue&type=template&id=826b7916&scoped=true", function () {
      api.rerender('826b7916', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/salesControl/placard/component/associationGoods.vue"
export default component.exports